import React from 'react'
import RedirectTemplate from 'src/components/template/redirect'
// export default (props) => {
//   return (
//     <USDefaultTemplate
//       location={props.location}
//       lang="en"
//       market="us"
//       video={videos.colorado_avalanche.videoUrl}
//       poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/GettyImages-1484175988.jpg?ch=width&auto=format,compress"
//       staticAnnotation={networkLogos.altitude}
//       title="Watch Colorado hockey live"
//       subtitle="STREAM THE AVALANCHE ON ALTITUDE SPORTS"
//       tagline="Anytime. Anywhere. From any device."
//       networkSet="hockey"
//       customNetworks={['altitude']}
//       logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-lockup-colorado-avalanche-v2.png?ch=width&auto=format,compress"
//       logoHeight="100px"
//       sportId={sportIds.Hockey}
//       leagueId={leagueIds.NHL}
//       teamId={teamIds['Colorado Avalanche']}
//     />
//   )
// }

export default (props) => {
  return <RedirectTemplate location={props.location} destination="/tv/" />
}
